export function getApiBase() {
  // Build-time only — env.sh / window.env injection removed.
  // In Docker the build does not receive REACT_APP_* vars,
  // so this always returns '' and the frontend uses relative URLs
  // (proxied by nginx to backend:3000 for all API routes).
  return process.env.REACT_APP_API_BASE_URL || '';
}